import ProjectTypeBadge, { ProjectType } from "components/ProjectTypeBadge";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import styles from "./styles.module.css";
import { IntegrationsAzureUsedByTableCellProps } from "./types";

const IntegrationsAzureUsedByTableTypeCell = ({
  item,
  ...cellProps
}: IntegrationsAzureUsedByTableCellProps) => {
  return (
    <TableSimpleCell {...cellProps}>
      <ProjectTypeBadge
        className={styles.typeCell}
        projectType={item.isModule ? ProjectType.Module : ProjectType.Stack}
      />
    </TableSimpleCell>
  );
};

export default IntegrationsAzureUsedByTableTypeCell;
